import { Option } from "../../components/shared/selectInput/types/selectInputProps";
import { genesisAndAgeTableList, tableRecord as genesisAndAgeTableRecord} from "../form/genesisAndAgeHelper";
import { subsoilTableList, tableRecord as subsoilTableRecord } from "../form/subsoilHelper";

export enum CollectivePreviewKey {
    miejscowoscL = "miejscowoscL",
    miejscowoscT = "miejscowoscT",
    geographicalLands = "geographicalLands",
    tectonicUnits = "tectonicUnits",
    sytuacjaGeomorfologiczna = "sytuacjaGeomorfologiczna",
    ukladGeologiczny = "ukladGeologiczny",
    rodzajMaterialu = "rodzajMaterialu",
    rodzajRuchu = "rodzajRuchu",
    charakterystykaOpis = "charakterystykaOpis",
    tectonics = "tectonics",
    skaly = "skaly",
    koluvia = "koluwium",
    waterMainSlope = "waterMainSlope",
    waterSlopeBelow = "waterSlopeBelow",
    waterSlopeOnsides = "SlopeOnsides",
    wiekiGeneza = "wiekiGeneza",
    liniePrzesylowe = "liniePrzesylowe",
    ocenaMozliwosci = "ocenaMozliwosci",
    stanBadan = "stanBadan",
    uwagi = "uwagi",
    ellaborators = "ellaborators",

    wskazania = "wskazania",
    glowneKryterium = "glowneKryterium",
}

export const collectiveViewCallback = (forms: any, keyName: CollectivePreviewKey, count: boolean, dic?: Option[], dics?: {[key: string]: Option[] | undefined}) => {
    switch (keyName) {
        case CollectivePreviewKey.miejscowoscL:
            return singleLandslideAttributeView(forms, count, "miejscowosC_NAZWA");
        case CollectivePreviewKey.geographicalLands:
            return arrayView(forms, count, "geographicalLands", "nazwa");
        case CollectivePreviewKey.tectonicUnits:
            return arrayView(forms, count, "tectonicUnits", "opis");
        case CollectivePreviewKey.sytuacjaGeomorfologiczna:
            return singleLandslideAttributeView(forms, count, "sytuacjA_GEOMORFOLOGICZNA_SID", dic);
        case CollectivePreviewKey.ukladGeologiczny:
            return singleLandslideAttributeView(forms, count, "uklaD_GEOLOGICZNY_SID", dic);
        case CollectivePreviewKey.rodzajMaterialu:
            return singleLandslideAttributeView(forms, count, "rodzaJ_MATERIALU_SID", dic);
        case CollectivePreviewKey.rodzajRuchu:
            return singleLandslideAttributeView(forms, count, "rodzaJ_RUCHU_SID", dic);
        case CollectivePreviewKey.charakterystykaOpis:
            return singleLandslideAttributeView(forms, count, "charakterystykA_OPIS");
        case CollectivePreviewKey.tectonics:
            return arrayView(forms, count, "tectonics", "rodzaJ_TEKTONIKI_SID", dic);
        case CollectivePreviewKey.skaly:
            return skalyViewCallback(forms, count, dics);
        case CollectivePreviewKey.koluvia:
            return arrayView(forms, count, "koluvia", "rodzaJ_KOLUWIUM_SID", dic);
        case CollectivePreviewKey.waterMainSlope:
            return watersView(forms, count, dic, 2);
        case CollectivePreviewKey.waterSlopeBelow:
            return watersView(forms, count, dic, 3);
        case CollectivePreviewKey.waterSlopeOnsides:
            return watersView(forms, count, dic, 4);
        case CollectivePreviewKey.wiekiGeneza:
            return wiekiGenezaViewCallback(forms, count, dics);
        case CollectivePreviewKey.liniePrzesylowe:
            return liniePrzesyloweView(forms, count, dic);
        case CollectivePreviewKey.ocenaMozliwosci:
            return singleLandslideAttributeView(forms, count, "dalszE_RUCHY");
        case CollectivePreviewKey.stanBadan:
            return stanBadanView(forms, count);
        case CollectivePreviewKey.uwagi:
            return singleLandslideAttributeView(forms, count, "uwagi");
        case CollectivePreviewKey.ellaborators:
            return ellaboratorsView(forms, count);
        
        case CollectivePreviewKey.miejscowoscT:
            return singleEndangeredAreaAttributeView(forms, count, "miejscowosC_NAZWA");
        case CollectivePreviewKey.wskazania:
            return singleEndangeredAreaAttributeView(forms, count, "wskazania");
        case CollectivePreviewKey.glowneKryterium:
            return glowneKryteriumView(forms, count, dics);
    };
}

const ellaboratorsView = (forms: any, count: boolean) => {
    const filled = forms
        .filter((f: any) => {
            return f.elaborators?.length > 0;
        });
    if (count) return filled.length;

    return filled.map((f: any) => {
        let items: string[] = [];
        f.elaborators?.forEach((p: any) => {
            const text = `${toStr(p.tytul)} ${toStr(p.imie)} ${toStr(p.nazwisko)} ${toStr(p.uprawnienia)} ${toStr(p.firmA_NAZWA)}`;
            items.push(text);
        });
        return {
            id: getId(f),
            value: items.join(" | ")
        }
    });
}

const stanBadanView = (forms: any, count: boolean) => {
    const filled = forms
        .filter((f: any) => {
            return f.publications?.length > 0 || f.documents?.length > 0;
        });
    if (count) return filled.length;

    return filled.map((f: any) => {
        let items: string[] = [];
        f.publications?.forEach((p: any) => {
            const text = `${p.details?.roK_POWSTANIA} ${p.details?.autorzy} ${p.details?.publikacjA_SOPO}`;
            items.push(text);
        });
        f.documents?.forEach((p: any) => {
            const text = `${p.rok} ${p.autorzy} ${p.tytul}`;
            items.push(text);
        });
        return {
            id: getId(f),
            value: items.join(" | ")
        }
    });
}

const watersView = (forms: any, count: boolean, dic?: Option[], filterValue?: number) => {
    const filteredForms = forms.map((f: any) => {
        return {
            id: getId(f),
            values: f.waters?.filter((dict: any) => {
                return dict.tyP_STREFY_SID === filterValue
            })
        }
    });

    const filled = filteredForms
        .filter((f: any) => {
            return f.values?.length > 0;
        });
    if (count) return filled.length;

    return filled.map((f: any) => {
        return {
            id: f.id,
            value: f.values.map((g: any) => decodeValue(g.tyP_PRZEJAWU_SID, dic)).join(", ")
        }
    });
}

const glowneKryteriumView = (forms: any, count: boolean, dics?: {[key: string]: Option[] | undefined}) => {
    const filled = forms
        .filter((f: any) => {
            return f.designationCriteria?.length > 0;
        });
    if (count) return filled.length;

    const mainDict = dics ? dics["mainDict"] : undefined;

    return filled.map((f: any) => {
        const records = f.designationCriteria
            .map((d: any) => {
                return `${decodeValue(d.kryT_WYZN_TZ_GLOWNE_ID, mainDict)} ${toStr(d.uzasadnienie)}`;
            });
        return {
            id: getId(f),
            value: records.join(" | ")
        }
    });
}

const skalyViewCallback = (forms: any, count: boolean, dics?: {[key: string]: Option[] | undefined}) => {
    const filled = forms
        .filter((f: any) => {
            return f.rocks.length > 0;
        });
    if (count) return filled.length;

    const rocksDict = dics ? dics["rocksDict"] : undefined;
    const stratigraficDict = dics ? dics["stratigraficDict"] : undefined;
    const rocksZalegDict = dics ? dics["rocksZalegDict"] : undefined;

    return filled.map((f: any) => {
        const records = subsoilTableList(f, rocksDict, stratigraficDict, rocksZalegDict)
            .map((s: subsoilTableRecord) => {
                return `${s.rodzaj} ${s.wiek} ${s.zaleganie}`;
            });
        return {
            id: getId(f),
            value: records.join(" | ")
        }
    });
}

const wiekiGenezaViewCallback = (forms: any, count: boolean, dics?: {[key: string]: Option[] | undefined}) => {
    const filteredForms = forms.map((f: any) => {
        return {
            id: getId(f),
            form: f,
            values: f.developments?.filter((dict: any) => {
                return dict.tyP_ZDARZENIA_SID === 1 //powstanie
            })
        }
    });

    const filled = filteredForms
        .filter((f: any) => {
            return f.values?.length > 0;
        });
    if (count) return filled.length;

    const MovementCauseDict = dics ? dics["MovementCauseDict"] : undefined;
    const EventeTypeDict = dics ? dics["EventeTypeDict"] : undefined;
    const PoraRokuDict = dics ? dics["PoraRokuDict"] : undefined;

    return filled.map((f: any) => {
        const records = genesisAndAgeTableList(f.form, MovementCauseDict, EventeTypeDict, PoraRokuDict)
            .map((s: genesisAndAgeTableRecord) => {
                return `${toStr(s.zdarzenie)} ${toStr(s.czas)} ${toStr(s.uwagi)} ${toStr(s.przyczyny)}`;
            });
        return {
            id: f.id,
            value: records.join(" | ")
        }
    });
}

const singleEndangeredAreaAttributeView = (forms: any, count: boolean, attributeName: string, dic?: Option[]) => {
    return singleAttributeView(forms, "endangeredAreaAttributes", count, attributeName, dic);
}

const singleLandslideAttributeView = (forms: any, count: boolean, attributeName: string, dic?: Option[]) => {
    return singleAttributeView(forms, "landslideAttributes", count, attributeName, dic);
}

const singleAttributeView = (forms: any, formAttributes: string, count: boolean, attributeName: string, dic?: Option[]) => {
    const filled = forms
        .filter((f: any) => {
            return hasValue(f?.[formAttributes]) && hasValue(f?.[formAttributes][attributeName]);
        });
    if (count) return filled.length;

    return filled.map((f: any) => {
        return {
            id: getId(f),
            value: decodeValue(f?.[formAttributes][attributeName], dic)
        }
    });
}

const decodeValue = (value: any, dic?: Option[]) => {
    if (dic) {
        const dictItem = dic.find(d => d.value === value);
        if (dictItem) { return dictItem.name; }
    }
    return value;
}

const liniePrzesyloweView = (forms: any, count: boolean, dic?: Option[]) => {
    const filled = forms
        .filter((f: any) => {
            var lines = toLiniePrzesylowe(f);
            return lines.length > 0;
        });
    if (count) return filled.length;

    return filled.map((f: any) => {
        var lines = toLiniePrzesylowe(f);
        return {
            id: getId(f),
            value: lines.map((line: any) => decodeValue(line, dic)).join(", ")
        }
    });
}

const toLiniePrzesylowe = (form: any) => {
    var lines: string[] = [];
    if (form.landslideAttributes?.liniE_ENERGETYCZNE) lines.push("liniE_ENERGETYCZNE");
    if (form.landslideAttributes?.liniE_TELEFONICZNE) lines.push("liniE_TELEFONICZNE");
    if (form.landslideAttributes?.liniE_WODOCIAGI) lines.push("liniE_WODOCIAGI");
    if (form.landslideAttributes?.liniE_KANALIZACJA) lines.push("liniE_KANALIZACJA");
    if (form.landslideAttributes?.liniE_GAZOCIAGI) lines.push("liniE_GAZOCIAGI");
    if (form.landslideAttributes?.liniE_INNE) lines.push("liniE_INNE");
    return lines;
}

const arrayView = (forms: any, count: boolean, attributeName: string, displayName: string, dic?: Option[]) => {
    const filled = forms
        .filter((f: any) => {
            return f[attributeName].length > 0;
        });
    if (count) return filled.length;

    return filled.map((f: any) => {
        return {
            id: getId(f),
            value: f[attributeName].map((g: any) => decodeValue(g[displayName], dic)).join(", ")
        }
    });
}

const getId = (form: any) => {
    if (form !== null && form.hasOwnProperty('landslideAttributes')) {
        return form.landslideAttributes.numeR_IDENTYFIKACYJNY;
    }
    return form?.endangeredAreaAttributes?.numeR_IDENTYFIKACYJNY;
}

const hasValue = (value: any) => {
    return value !== null && value !== undefined && value !== '';
}

const toStr = (value: any) => {
    return value === null || value === undefined ? '' : value;
}
